/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfOperationalContactDetailDto } from "../models/AjaxResponseOfOperationalContactDetailDto";
import type { AjaxResponseOfPagedResultDtoOfOperationalContactListDto } from "../models/AjaxResponseOfPagedResultDtoOfOperationalContactListDto";
import type { CreateOrUpdateOperationalContactInput } from "../models/CreateOrUpdateOperationalContactInput";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class OperationalContactsAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfPagedResultDtoOfOperationalContactListDto Success
   * @throws ApiError
   */
  public getAll({
    filter,
    linkedState,
    organizationId,
    sorting,
    skipCount,
    maxResultCount,
  }: {
    filter?: string;
    linkedState?: string;
    organizationId?: number;
    sorting?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfPagedResultDtoOfOperationalContactListDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/operational/contacts",
      query: {
        filter: filter,
        linkedState: linkedState,
        organizationId: organizationId,
        sorting: sorting,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }
  /**
   * @returns AjaxResponseOfOperationalContactDetailDto Success
   * @throws ApiError
   */
  public create({
    requestBody,
  }: {
    requestBody?: CreateOrUpdateOperationalContactInput;
  }): CancelablePromise<AjaxResponseOfOperationalContactDetailDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/operational/contacts",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns void
   * @throws ApiError
   */
  public delete({ contactId }: { contactId: number }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/operational/contacts/{contactId}",
      path: {
        contactId: contactId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfOperationalContactDetailDto Success
   * @throws ApiError
   */
  public get({
    contactId,
  }: {
    contactId: number;
  }): CancelablePromise<AjaxResponseOfOperationalContactDetailDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/operational/contacts/{contactId}",
      path: {
        contactId: contactId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfOperationalContactDetailDto Success
   * @throws ApiError
   */
  public update({
    contactId,
    requestBody,
  }: {
    contactId: number;
    requestBody?: CreateOrUpdateOperationalContactInput;
  }): CancelablePromise<AjaxResponseOfOperationalContactDetailDto> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/operational/contacts/{contactId}",
      path: {
        contactId: contactId,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
}
